export interface ArchivedItem {
  id: string;
  label: string;
  isPii?: boolean;
}
